import axios from "axios";
import { URLEndpoints } from "../../constants/urlConstants";

export const getTerms = async (instanceUniqueId) => {
  const SERVER = process.env.REACT_APP_NODEJS_SERVER_URL;
  const headers = { headers: { accessToken: localStorage.getItem("accessToken") } };

  try {
    if (instanceUniqueId) {
      const instanceRes = await axios.get(
        `${SERVER}/instances/byinstanceUniqueId/${instanceUniqueId}`,
        headers
      );
      const instanceId = instanceRes?.data?.id ?? null;
      if (instanceId) {
        const response = await axios.get(`${SERVER}/instances/${instanceId}/terms`, headers);
        return response.data;
      }
    }

    const response = await axios.get(`${SERVER}/${URLEndpoints.terms}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
